var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTextGlitch',{attrs:{"fill":"#374151","text":_vm.text,"background":"","highlight2":"cyan"}})
}
var staticRenderFns = []

export { render, staticRenderFns }